import * as React from 'react';
import Table from 'ted-ui/build/Table';
import { IProductsTableProps } from '../../../../../../config/order-tracker-new-common/types';
import useTableSorting from '../../../../hooks/use-table-sorting';

const ProductsTable = ({
  productsTableColumns,
  productsTableData,
}: IProductsTableProps) => {
  const { sortBy,
          sortOrder,
          onSortFunction,
          sortData } = useTableSorting(productsTableData);
  return (
    <Table
      columns={productsTableColumns}
      data={sortData}
      border={'default'}
      spacing={'comfortable'}
      textAlign="left"
      stripe={true}
      onSortFunction={onSortFunction} sortBy={sortBy} sortOrder={sortOrder}
    />
  );
};

export default ProductsTable;
